import fbPng from "../../assests/icons/fb.png";
import twitterPng from "../../assests/icons/twit.png";
import linkedInPng from "../../assests/icons/in.png";
import HitCounter from "../../pages/public/hitCounter";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <div className="div-footermenu">
      <div className="footer-social-menu">
        <a href="#">
          <img
            src={fbPng}
            alt="Connect Us On Facebook"
            border="0px"
            style={{ width: "20px", height: "20px" }}
          />
        </a>
        &nbsp;
        <a href="#">
          <img
            src={twitterPng}
            alt="Connect Us On Twitter"
            border="0px"
            style={{ width: "20px", height: "20px" }}
          />
        </a>
        &nbsp;
        <a href="#">
          <img
            src={linkedInPng}
            alt="Connect Us On LinkedIn"
            border="0px"
            style={{ width: "20px", height: "20px" }}
          />
        </a>
        {/* <div className="Table footer-copyright">  <HitCounter />
        </div> */}
      </div>
      <div className="Table footer-copyright">
        Copyrights © {currentYear} Maratha Hitawardhak Mandal Dombivli. All
        Rights Reserved
      </div>
      <div className="footer-link">www.marathamandaldombivli.org</div>
    </div>
  );
}
